// Plan names taken from Zervant https://github.com/Zervant/zervant-ui/blob/master/src/client/components/Subscription/PremiumPlans/IPremiumInterface.ts
export enum ZervantSubscriptionPlanName {
  AgerasBasic = 'plan.ageras_basic',
  AgerasFree = 'plan.ageras_free',
  AgerasPlus = 'plan.ageras_plus',
  AgerasStart = 'plan.ageras_start',
  ContactUs = 'plan.contact_us',
  Free = 'plan.free',
  Growth = 'plan.growth',
  Merchant = 'plan.merchant',
  None = 'plan.none',
  Pro = 'plan.pro',
  Starter = 'plan.starter',
}
